import { css } from "@emotion/react";
import { LAYOUT_HEIGHTS } from "constants/layoutHeights";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const containerStyle = css`
  background-color: #f5f5f5;
  display: flex;
  min-height: calc(
    100vh - ${LAYOUT_HEIGHTS.HEADER_BREADCRUMB_FOOTER_HEIGHT_PC}px
  ); // 親の要素がPC基準の高さで調整されているためPC用の定数を使用
  flex-direction: column;
  row-gap: 24px;
  align-items: center;
  padding: 24px 20px;

  // 下部の白い領域を画面下まで伸ばすための調整
  margin-bottom: -80px;
  ${MEDIA_QUERY_FOR_PC} {
    padding-bottom: 80px;
  }
  ${MEDIA_QUERY_FOR_SP} {
    padding-bottom: 24px;
  }
`;

export const titleStyle = css`
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #333;
  align-self: flex-start;
`;

export const listContainerStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  align-items: flex-start;

  ${MEDIA_QUERY_FOR_PC} {
    width: 640px;
  }
  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
    min-width: 360px;
  }
`;
